import React, { ReactNode } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, IconButton, Snackbar } from '@mui/material';

interface NotifierConfirmProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onClick: () => void;
  readonly message: string;
  readonly messageSecondary?: ReactNode;
  readonly buttonText: string;
}

export function NotifierConfirm({
  open,
  onClose,
  onClick,
  message,
  messageSecondary,
  buttonText,
}: NotifierConfirmProps) {
  return (
    <Snackbar
      sx={{
        mt: 10,
        zIndex: 10000000,
        '& div:first-child': {
          '& div:first-child': {
            width: '100%',
          },
        },
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={open}
      onClose={onClose}
      slotProps={{ content: { 'aria-describedby': 'message-id' } }}
      message={
        <Box sx={{ width: '100%' }} id="message-id">
          {message}
          <br />
          {messageSecondary}
        </Box>
      }
      action={[
        <Button sx={{ bgcolor: '#F3D06E' }} variant="contained" key={buttonText} size="small" onClick={onClick}>
          {buttonText}
        </Button>,
        <IconButton key="close" aria-label="Close" color="inherit" sx={{ p: 1, ml: 1 }} onClick={onClose}>
          <CloseIcon />
        </IconButton>,
      ]}
    />
  );
}
